<script context="module" lang="ts">
  import { writable } from 'svelte/store';

  let isVisible = writable(false);

  export function openConnectDiscordModal() {
    isVisible.set(true);
  }

  export function closeConnectDiscordModal() {
    isVisible.set(false);
  }
</script>

<script lang="ts">
  import type { App } from '$lib/types';

  import { getContext } from 'svelte';
  import { session } from '$lib/stores';

  import Dialog from '$mds/Dialogs/Dialog.svelte';
  import OAuthButton from '$components/OAuthButton.svelte';
  import Button from '$mds/Buttons/Button';

  import IconWrapper from '$mds/IconWrapper';
  import { faDiscord } from '@fortawesome/free-brands-svg-icons';

  const { refreshSession } = getContext<App>('app');

  let oAuthButton: OAuthButton;

  async function onSuccess() {
    closeConnectDiscordModal();
    const { accessToken, refreshToken } = session.get();
    await refreshSession(accessToken!, refreshToken!);
  }
</script>

<Dialog isOpen={$isVisible} allowCloseOnNavigation={false} scrollerClass="" title="Connect with your coach">
  <p class="text-left">
    To ensure your session starts on time, please verify your Discord account so your coach can easily reach you if
    needed.
  </p>

  <div class="border-ondark-subtle mt-4 flex items-center gap-4 rounded-lg border p-3 text-left">
    <div class="bg-brands-discord text-ondark-primary flex size-12 shrink-0 items-center justify-center rounded-lg">
      <IconWrapper size="lg" icon={faDiscord} />
    </div>

    <div class="flex flex-1 flex-col justify-between">
      <span class="text-body-md text-ondark-primary">Discord</span>
      <span class="text-body-2xs text-ondark-secondary">Connect your discord</span>
    </div>

    <Button on:click={() => oAuthButton.onClick()}>Connect</Button>
  </div>

  <OAuthButton bind:this={oAuthButton} provider="discord" type="connect" class="hidden" on:success={onSuccess} />
</Dialog>
